module.exports = __webpack_public_path__ + "static/media/previous-night.dabeb65a.svg";